import { DatePipe } from '@angular/common';
import { HttpParams } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CommonService } from 'src/app/services/common.service';
import { DataService } from 'src/app/services/data.service';
import { ConfirmationDialogComponent } from 'src/app/shared/components/confirmation-dialog/confirmation-dialog.component';
import { Router } from '@angular/router';
import { EncryptDecryptService } from 'src/app/services/encrypt-decrypt.service';
import {MemoryStorageService} from 'src/app/services/memory-storage.service';

@Component({
  selector: 'app-upload-file',
  templateUrl: './upload-file.component.html',
  styleUrls: ['./upload-file.component.css']
})
export class UploadFileComponent implements OnInit {

  fileControlType = 'file'; //for SSA fixing (we have checked upload file type)
  supportDocValidFileExtensions = ['PDF', 'EXCEL', 'TIFF', 'TIF', 'XLSX', 'CSV'];
  supportDocFileSize = 100;
  attachmentList = [];
  uploadFileName = 'uploadFileName';
  fileBase64FileString: string = '';
  dateFormat = new DatePipe('en-US');
  isShowUploadedDocs: boolean = false;
  lstHeaders = [];
  lstFiles = [];
  lstColumnsToHide = [];

  ModuleList: any = [];
  selectedModule: any = {};
  constructor(public commonService: CommonService, private dialog: MatDialog, private dataService: DataService, private route: Router, private encryptdecryptservice: EncryptDecryptService,private memorystore: MemoryStorageService) { }

  ngOnInit(): void {
    this.getFileModule();
  }

  onSelectFile(imgFile: any) {
    this.uploadFileName = '';

    let arrExt = this.selectedModule.extension.toString().split(",");

    if (this.commonService.validateFileUpload(imgFile.target.files[0], arrExt, this.supportDocFileSize)) {
      if (imgFile.target.files && imgFile.target.files[0]) {

        this.uploadFileName = imgFile.target.files[0].name;
        let reader = new FileReader();
        reader.onload = (e: any) => {
          this.fileBase64FileString = reader.result.toString();
          this.uploadAttachment();
        };
        reader.readAsDataURL(imgFile.target.files[0]);
      } else {
        this.uploadFileName = '';
      }
    } else {
      this.uploadFileName = '';
    }
  }

  getFileModule() {
    let param = new HttpParams;

    // // param = param.append("project_id", this.commonService.getUserInfoFromLocalStorage("projectId"));
    // // param = param.append("subgroup_id", this.commonService.getUserInfoFromLocalStorage("subgroupId"));
    // param = param.append("project_id", this.memorystore.getItem("projectId"));
    // param = param.append("subgroup_id", this.memorystore.getItem("subgroupId"));
    param = param.append("project_id", this.encryptdecryptservice.encryptUsingAES256(this.memorystore.getItem("projectId")));
    param = param.append("subgroup_id", this.encryptdecryptservice.encryptUsingAES256(this.memorystore.getItem("subgroupId")));
    this.dataService.getData('get-file-module', param).subscribe((res) => {
      if (res != null && (res.error_message == null || res.error_message == "")) {
        if (res != null && res.status == true) {
          this.ModuleList = res.data;
        }
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.route.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error")
        }
      }
    },
      error => {
        if (error.includes("401")) {
          this.route.navigateByUrl('/unauthorized');
          return;
        }
      });
  }

  onSelectModule(module: any) {
    this.getUploadedFiles();
  }

  uploadAttachment() {
    if (
      this.uploadFileName == '' ||
      this.uploadFileName == undefined ||
      this.uploadFileName == 'Choose File' ||
      this.fileBase64FileString.length == 0
    ) {
      this.commonService.showMessageBox('Please choose attachment.', 'Alert');
      return;
    }
    let local_file_name = this.uploadFileName.split('.').slice(0, -1).join('.')
    let local_extension = '.' + this.uploadFileName.split('.').pop();
    let selected_file_name = this.dateFormat.transform(new Date(), 'yyyyMMddhhmmssSSS') + "^" + local_file_name.substring((local_file_name.length < 24 ? 0 : local_file_name.length - 24), (local_file_name.length < 24 ? local_file_name.length : 24));

    this.attachmentList.push({
      name: selected_file_name + local_extension,
      file: this.fileBase64FileString,
    });
    this.uploadFileName = 'Choose File';
    this.fileBase64FileString = '';
    this.commonService.showMessageBox('File added in the queue.', 'Success');
  }

  deleteAttachment(index: number) {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      disableClose: true,
      data: {
        message: 'Are you sure want to delete this attachment?',
        buttonText: {
          ok: 'Yes',
          cancel: 'No',
        },
      },
    });
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.attachmentList.splice(index, 1);
        this.commonService.showMessageBox('Attachment deleted.', 'Success');
      }
    });
  }

  uploadFiles() {
    let uploadedCount = 0;
    this.attachmentList.forEach((item) => {
      uploadedCount++;
      let attachmentBody = {
        // user_id: Number(this.commonService.getUserInfoFromLocalStorage('userId')),
        user_id: Number(this.memorystore.getItem('userId')),
        attachment_name: item.name,
        attachment_encoded: item.file,
        module_id: Number(this.selectedModule.module_id)
      };

      this.dataService.postData('upload-files', attachmentBody).subscribe((res) => {
        if (res) {
          if (uploadedCount == this.attachmentList.length) {
            this.commonService.showMessageBox(this.attachmentList.length + ' file(s) uploaded successfully.', 'Success');
            this.attachmentList = [];
            this.getUploadedFiles();
          }
        }
      });
    });
  }

  getUploadedFiles() {

    this.lstFiles = [];
    this.lstHeaders = [];

    let params = new HttpParams();
    params = params.append('module_id', this.selectedModule.module_id.toString());
    params = params.append('status', '');

    this.dataService.getData('get-uploaded-files', params).subscribe(
      (res) => {
        if (res != null && (res.error_message == null || res.error_message == "")) {
          if (res.data != null) {
            if (res.data.length > 0) {
              this.lstColumnsToHide.push("File Path");
              this.lstColumnsToHide.push("File Type");
              this.lstHeaders = res.data[0].table_sections;
              this.lstFiles = res.data[0].table_data;
            }
          }
        }
        else {
          if (res.errorCode != 0 && res.errorCode == 4000) {
            this.route.navigateByUrl('/unauthorized');
            return;
          }
          if (res.errorCode != 0 && res.errorCode == 3000) {
            this.commonService.showMessageBox("Internal error")
          }
        }
      },
      error => {
        if (error.includes("401")) {
          this.route.navigateByUrl('/unauthorized');
          return;
        }
      });
  }

}
